import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable()
export class BankAccountService {
    constructor(private http: HttpClient) {}

    getByUserId(user_id): Observable<any> {
        return this.http.get(environment.api_url + `/user/${user_id}/bank-accounts`);
    }

    create(user_id, lead_id, iban): Observable<any> {
        return this.http.post(environment.api_url + `/user/${user_id}/bank-accounts/create`, {
            user_id: user_id,
            lead_id: lead_id,
            iban: iban
        });
    }
}
